import gql from 'graphql-tag';

export const getServiceRequestByIdQuery = gql(`
  query getServiceRequestByIdQuery($serviceRequestId: String!) {
    serviceRequest(serviceRequestId: $serviceRequestId) {
      channelId {
        name
        id
      }
      serviceRequestId
      createdBy {
        name
        id
      }
      submitOnBehalfOf {
        name
        id
      }
      createdAt
      updatedAt
      updatedBy {
        name
        id
      }
      description
      category
      issue
      location
      floor
      company {
        name
        id
      }
      contentId
      extRefId
      suite
      assignee {
        name
        id
      }
      status
      customQuestions {
        Question
        Answer
      }
      assigneeGroups
      attachmentRefId
      isBillable
      equipment
      friendlyID
      notes
      hours
      userFriendlyID
      displayMetadata {
        provider
        friendlyId
      }
      nextStatuses
      suiteIds {
        sourceEntityId
      }
      scheduledDueDate
      taskTimeInMinutes
      feedback {
        rating
        comment
        submittedAt
        userId
      }
      task {
        id
        userFriendlyID
      }
    }
  }
`);
